import React, { FunctionComponent, useContext } from 'react'
import { Button, List, Typography } from 'antd'
import { AimOutlined, SettingOutlined } from '@ant-design/icons'
import { Vehicle, VehicleLocation } from 'server'
import { AuthContext } from '@strac/react-client-auth'
import VehicleLocationUpdateTime from '../../../components/Display/VehicleLocationUpdateTime/VehicleLocationUpdateTime'
import DisplayAgency from '../../../components/Display/DisplayAgency/DisplayAgency'
import Highlighter from 'react-highlight-words'
import { useMap } from '@vis.gl/react-google-maps'
import { MapSettingsContext } from '../../../contexts/MapSettingsContext'
import MapSettingsContextInterface from '../../../contexts/MapSettingsContext/MapSettingsContextInterface'
import { canEditAgency } from '../../../utils/auth'

interface IProps {
  vehicle: Vehicle
  vehicleLocation: VehicleLocation
  handleEditVehicle: any
  search: string
}

const DeviceListItem: FunctionComponent<any> = (props: IProps) => {
  const { vehicle, vehicleLocation, handleEditVehicle, search } = props

  const { authUser } = useContext(AuthContext) as any

  const { followedVehicleId, setFollowedVehicleId } = useContext(
    MapSettingsContext
  ) as MapSettingsContextInterface

  const map = useMap()

  let editOwnAgency = canEditAgency(authUser, vehicle)

  const handleLocate = () => {
    if (followedVehicleId === vehicle.vehicle_id) {
      setFollowedVehicleId(undefined)
      return
    } else {
      const latLng = new google.maps.LatLng(vehicleLocation.latitude, vehicleLocation.longitude)
      map?.panTo(latLng)
      const mapZoom = map?.getZoom()
      if (mapZoom && mapZoom < 15) map?.setZoom(15)
      setFollowedVehicleId(vehicle.vehicle_id)
    }
  }

  const actions = [
    <Button
      type={followedVehicleId === vehicle.vehicle_id ? 'primary' : 'default'}
      key={'locate'}
      icon={<AimOutlined />}
      onClick={handleLocate}
    />,
    <Button
      disabled={!editOwnAgency}
      key={`${vehicle.vehicle_id}-vehicle-settings`}
      icon={<SettingOutlined />}
      onClick={() => handleEditVehicle(vehicle)}
    />
  ]

  return (
    <List.Item actions={actions}>
      <List.Item.Meta
        title={
          <Typography.Text ellipsis={true}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[search]}
              autoEscape
              textToHighlight={`${vehicle.name}`}
            />
          </Typography.Text>
        }
        description={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <DisplayAgency agencyId={vehicle.agency_id} />
            <VehicleLocationUpdateTime vehicleId={vehicle.vehicle_id} />
          </div>
        }
      />
    </List.Item>
  )
}

export default DeviceListItem
